export const TIMEZONE_OFFSET_MIN = -1440;
export const TIMEZONE_OFFSET_MAX = 1440;
export const TIMEZONE_OFFSET_STORAGE_KEY = 'afl_timezone_offset';

export const getBrowserTimezoneOffsetMinutes = () => new Date().getTimezoneOffset();

export const clampTimezoneOffset = (value) => {
  if (value === '' || value == null) return null;
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return null;
  if (parsed < TIMEZONE_OFFSET_MIN || parsed > TIMEZONE_OFFSET_MAX) return null;
  return parsed;
};

export const getStoredTimezoneOffset = () => {
  try {
    return clampTimezoneOffset(window.localStorage.getItem(TIMEZONE_OFFSET_STORAGE_KEY));
  } catch (error) {
    return null;
  }
};

export const persistTimezoneOffset = (value) => {
  const parsed = clampTimezoneOffset(value);
  try {
    if (parsed == null) window.localStorage.removeItem(TIMEZONE_OFFSET_STORAGE_KEY);
    else window.localStorage.setItem(TIMEZONE_OFFSET_STORAGE_KEY, String(parsed));
  } catch (error) {
    // ignore quota / private mode
  }
  return parsed;
};

export const getLoginTimezoneOffset = () => {
  const stored = getStoredTimezoneOffset();
  if (stored != null) return stored;
  return clampTimezoneOffset(getBrowserTimezoneOffsetMinutes());
};
